<template>
  <button
    :class="classState"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <BaseIcon
      :svgPath="svgPath"
      :isHover="hover"
      :id="id"
      :classState="renderClass"
    ></BaseIcon>
  </button>
</template>

<script>
import BaseIcon from "@/lib/tui/components/buttons/BaseIcon.vue";

export default {
  name: "BaseButtonIcon",
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  components: {
    BaseIcon,
  },
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  props: {
    id: [String, Number],
    label: [String, Boolean],
    svgPath: String,
    classState: String,
    isReverted: { type : Boolean, default: false },
  },
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  data() {
    return {
      hover: false,
    };
  },
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  computed: {
    renderClass: function () {
      let newClass = this.classState;

      newClass += this.hover ? ' hover' : '';
      return newClass;
    },
  }
};
</script>

<style lang="scss">
@import "@/lib/tui/scss/module/baseButton.scss";
@import "@/lib/tui/scss/module/trinnovButton.scss";
</style>
